import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from './services/config.service';
import { AppsettingsConfig } from './models/client-config';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ConfigService],
})
export class ClientConfigModule {}
